<template>
<div class="heroCarousel">
    <flickity :options="flickityOptions" ref="flickityRef">
        <slot></slot>
    </flickity>
    <button @click="$refs.flickityRef.previous()" class="btn heroCarousel-button heroCarousel-button_left">
        <span class="isVisuallyHidden">Previous</span>
        <i class="icon icon_arrow_light"></i>
    </button>
    <button @click="$refs.flickityRef.next()" class="btn heroCarousel-button heroCarousel-button_right">
        <span class="isVisuallyHidden">Next</span>
        <i class="icon icon_arrow_light_right"></i>
    </button>
</div>
</template>

<script>
import Flickity from '../Flickity/Flickity.vue'
import {debounce} from '../../utilities/debounce.js';

export default {
    components: {
        Flickity
    },
    data() {
        return {
            flickity: {
                wrapAround: true,
                pageDots: true,
                prevNextButtons: false,
                friction: 0.6,
                percentPosition: false,
            }
        }
    },
    computed: {
        flickityOptions() {
            let options = {}
            if (this.$root.windowWidth > 768) {
                options.pageDots = false;
            }

            if (typeof this.$refs.flickityRef !== 'undefined') {
                //debounce required since resize fires so often Vue flags as possible infinite loop
                this.debounceRenderFlickity();
            }
            return Object.assign({}, this.flickity, options);
        }
    },
    methods: {
        debounceRenderFlickity: debounce(function() { this.$refs.flickityRef.rerender() }, 400)
    }
}
</script>

<style lang="scss">
</style>

